<script setup>
import { computed } from 'vue'
import PredefinedValuesInputComponent from '../../PredefinedValuesInputComponent.vue'

const props = defineProps({
  value: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['change'])

const impactOptions = computed(() =>
  [
    { label: 'Mõju vara väärtusele ei ole täheldatav', value: '0' },
    { label: 'Mõju väärtusele on positiivne', value: '2' },
    { label: 'Mõju väärtusele on negatiivne', value: '3' },
    { label: 'Mõju väärtusele puudub', value: '4' },
    { label: '-', value: '5' },
  ].map(option => ({ option })),
)

const headerClass = 'bg-gray-200 dark:bg-surface-900'
</script>

<template>
  <div class="rounded-lg overflow-hidden shadow-md">
    <!-- Bind DataTable value directly to the prop -->
    <DataTable :value="props.value" rowGroupMode="subheader" groupRowsBy="esg.group" showGridlines>
      <template #empty>
        <div class="flex justify-center items-center h-full">
          <ProgressSpinner style="width: 3rem; height: 3rem" />
        </div>
      </template>
      <Column header="ESG" field="esg.group"></Column>
      <Column header="Tegur" field="factor" style="max-width: 420px" :headerClass="headerClass"></Column>
      <Column header="Iseloomustus" field="description" style="max-width: 320px" :headerClass="headerClass" bodyClass="text-sm">
        <template #body="slotProps">
          <div v-html="slotProps.data.description"></div>
        </template>
      </Column>
      <Column header="Kvantitatiivne või kvalitatiivne hinnang" field="evaluation" :headerClass="headerClass" style="min-width: 300px; max-width: 300px">
        <template #body="slotProps">
          <!-- v-model bindings will modify the objects within the props.value array directly -->
          <div v-if="slotProps.data.evaluation?.type === 'select'">
            <Select v-model="slotProps.data.evaluation.value" :options="slotProps.data.evaluation.options" fluid @update:model-value="emit('change')" />
          </div>
          <div v-else>
            <Textarea v-model="slotProps.data.evaluation" rows="1" autoResize fluid @update:model-value="emit('change')" />
          </div>
        </template>
      </Column>
      <Column header="Mõju väärtusele ja leevendusmeetmed" field="impact" :headerClass="headerClass">
        <template #body="slotProps">
          <!-- Ensure v-model works correctly with the array passed in props -->
          <predefined-values-input-component
            category="main"
            :name="slotProps.data.factor"
            :append-on-select="true"
            :options="impactOptions"
            v-model="slotProps.data.impact"
            placeholder="Mõju väärtusele ja leevendusmeetmed"
            @update:model-value="emit('change')"
          />
        </template>
      </Column>
      <Column header="Viide hinnangus olevale detailsemale infole" field="reference" :headerClass="headerClass">
         <template #body="slotProps">
             <Textarea v-model="slotProps.data.reference" rows="1" autoResize fluid @update:model-value="emit('change')" />
         </template>
      </Column>

      <template #groupheader="slotProps">
          <div class="flex items-center gap-2 font-bold">
              <span>{{ slotProps.data.esg.group }}</span>
          </div>
      </template>
    </DataTable>
  </div>
</template>

<style scoped>
  @reference '../../../../css/tailwind.css';

:deep(.p-datatable-row-group-header) {
  @apply bg-gray-100 dark:bg-surface-800;
}
</style>